import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { sort } from "../../utils/utils";
import { Selector } from "./Selector";

export const CycleSelect = ({
  label,
  selectedCycle,
  selectHandler,
  cycles,
  interaction = true,
  templateIncludeGoals = false,
}) => {
  const { t } = useTranslation();

  function getOptionDisabledReason(option) {
    if (templateIncludeGoals && option.goals.length === 0) {
      return t("planTemplates.requiresGoals");
    }
    return null;
  }

  return (
    <Selector
      id="cycle-selector"
      label={label ?? t("cyclesAndGoals.cycle")}
      assistiveText={t("cyclesAndGoals.cycleSelect")}
      selectHandler={selectHandler}
      options={sort(cycles, (cycle) => cycle.label)}
      selectedItemId={selectedCycle.id ?? ""}
      interaction={interaction}
      getOptionDisabledReason={getOptionDisabledReason}
    />
  );
};

export const CycleSelectDashboard = ({
  selectHandler,
  cycles,
  selectedCycle,
  loadedCycles,
}) => {
  const { t } = useTranslation();

  return loadedCycles ? (
    <Selector
      id="cycle-selector"
      size="small"
      options={cycles.map((cycle) => ({ id: cycle.id, label: cycle.name }))}
      selectHandler={selectHandler}
      selectedItemId={selectedCycle?.id ?? ""}
      label={t("filter.cycle")}
    />
  ) : (
    <Skeleton
      count={1}
      style={{ width: "100%", height: 24, borderRadius: 5 }}
    />
  );
};
